import { QPanelDragger } from "./QPanelDragger";
import { Globals } from "./Globals";

export class QFramelessPanelDragger extends QPanelDragger {
  constructor() {
    super();
  }

  InteractWithElement(x, y) {
    var sx = this.fParentPanel.GetPositionX();
    var sy = this.fParentPanel.GetPositionY();

    var deltaX = x + sx - this.fStartX;
    var deltaY = y + sy - this.fStartY;

    this.fParentPanel.PositionPanel(sx + deltaX, sy + deltaY);
    this.fStartX = x + sx;
    this.fStartY = y + sy;

    var n = this.fAssociatedPanels.length;
    for (var i = 0; i < n; i++) {
      var p = this.fAssociatedPanels[i];
      sx = p.GetPositionX();
      sy = p.GetPositionY();
      p.PositionPanel(sx + deltaX, sy + deltaY);
      if (Globals._wsMgr) Globals._wsMgr.MakePanelTop(p);
    }
    this.fParentPanel.DoInteractWithElement(x, y);
  }
}
